import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';

// Components
import Anime from '../../components/Anime/Anime';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import CallToAction from '../../containers/CallToAction/CallToAction';

class PageSupportPolicy extends Component {


    render () {
         return (
            <div className="app-section">
                <MetaTags>
                    <title>Support Policy</title>
                    <meta 
                        name="description" 
                        content="Read our support policy?" 
                    />
                </MetaTags>

                <div className="container">
                    <ContentHeader 
                        title="Support Policy" 
                        subTitle="Just for the record: we provide theme assistance because we consider ourselves as proffesionals and not because it is required from Envato authors. We will do our best to answer all your questions and help you, but sometimes you have to be patient." 
                        classes="" 
                    />

                    <div className="row row-large-gutter">
                	 	
                        <div className="col-lg-7 col-md-6 col-12 mb mb-md">
                        	<Anime type="fade-up" delay="3" duration="3">
		                        <h2>Range of support</h2>
		                        <h6>Happy to help</h6>
		                        <ul className="check-list">
		                            <li>
		                                Assistance installing and setting up the product;
		                            </li>
		                            <li>
		                                Answering questions about the theme and its features;
		                            </li>
		                            <li> 
		                                Product bug fixes;
		                            </li>
		                        </ul>
		                        <h6>Cannot help</h6>
		                        <ul className="x-list">
		                            <li>
		                                Compatibility with 3rd party plugins;
		                            </li>
		                            <li>
		                                Customizations (anything more than a few lines of CSS);
		                            </li>
		                            <li>
		                                Creating layouts/elements that are not present on the demo site;
		                            </li>
		                            <li>
		                                Server technical assistance & configuration;
		                            </li>
		                        </ul>

		                        <p> We focus on topics like installation and configuration of the theme, usage of theme features and potential bugs fix. We do not provide general <a href="https://wordpress.org/">WordPress support</a>. Please refer to the <a href="https://wordpress.org/support/">WordPress.org</a> forums for general WordPress support.</p>
		                        <p>Unfortunately, our support is not the best place for asking general WordPress questions. We’d happily answer every question you could throw at us, if there was enough time in the day! So we ask that you focus on asking theme-specific questions while seeking help.</p>
	                    	</Anime>
                    	</div>

	                    <div className="col-lg-5 col-md-6 col-12 mb mb-md">
	                        <Anime type="fade-up" delay="4" duration="3">
		                        <h3>Before you ask</h3>
		                        <p>Make sure  that you have read documentation which was in theme package - it contains useful information on how to install and use the theme. You may be familiar with our FAQ section too.</p>
		                        <h3>Support hours</h3>
		                        <p>Rascals Themes office is located in Poland (EU) and our working hours are 8:00AM - 4:00PM (GMT +1) on workdays (Monday to Friday excluding public holidays). Please be mindful of potentially slower response times due to time difference depending on your time-zone.</p>
		                        <h3>Bug fixing</h3>
		                        <p>We are committed to regularly updating our products. If you found a bug, please report it to our support team for them to investigate. Security related bug is fixed immediately and an update released as soon as practicably possible.</p>
	                        </Anime>

	                    </div>
	                </div>
                </div>

                <CallToAction 
                    buttonTitle="Get a Free Quote"
                    buttonLink="/contact"
                    text="You need professional customization for your theme?"
                    classes="cta--full cta--color cta--center"
                />
            </div>
        );
    }
}

export default PageSupportPolicy;


// WEBPACK FOOTER //
// ./src/pages/PageSupportPolicy/PageSupportPolicy.js